import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';

import { useTransition } from '../../../utils/cssTransitions';
import { Children, ReturnComponent } from '../../../utils/reactTypes';
import {
    TRANSITION_PROPERTIES,
    appBarHeightDesktop,
    appBarHeightMobile,
    closedNavDrawerWidthDesktop,
    closedNavDrawerWidthMobile,
    isGlobalDrawerOpenAtom,
    openNavDrawerWidth,
} from '../lib/constants';
import { useIsGlobalNavMobile } from '../lib/hooks';

export const GlobalNavigationDrawerAndAppBarOffset = ({
    children,
}: {
    children: Children;
}): ReturnComponent => {
    const isMobile = useIsGlobalNavMobile();
    const isDrawerOpen = useAtomValue(isGlobalDrawerOpenAtom);
    const transition = useTransition(TRANSITION_PROPERTIES);

    const appBarHeight = isMobile ? appBarHeightMobile : appBarHeightDesktop;

    // Calculate drawer width based on state
    let navigationDrawerWidth: string;
    if (isMobile) {
        navigationDrawerWidth = closedNavDrawerWidthMobile;
    } else if (isDrawerOpen) {
        navigationDrawerWidth = openNavDrawerWidth;
    } else {
        navigationDrawerWidth = closedNavDrawerWidthDesktop;
    }

    return (
        <Box
            sx={{
                marginTop: appBarHeight,
                marginLeft: navigationDrawerWidth,
                width: `calc(100% - ${navigationDrawerWidth})`,
                transition,
            }}
        >
            {children}
        </Box>
    );
};
